/* global axios */
import ApiClient from './ApiClient';
import store from '../store';

class KanbanConfigAPI extends ApiClient {
    constructor() {
        super('kanban_config', { accountScoped: true });
    }

    get accountId() {
        return store.state.auth.currentUser.account_id;
    }

    async getConfig() {
        try {
            const response = await axios.get(this.url);
            return response;
        } catch (error) {
            // Se não existir configuração, cria uma nova com dados padrão
            if (error.response?.status === 404) {
                const defaultData = {
                    enabled: false,
                    webhook_url: '',
                    webhook_secret: '',
                    webhook_events: [],
                    config: {
                        title: 'Kanban',
                        default_view: 'kanban',
                        auto_assignment: false,
                        notifications_enabled: false,
                        support_email: '',
                        support_phone: '',
                        support_chat_hours: '',
                        support_chat_enabled: false,
                        dragbar_enabled: true
                    }
                };

                try {
                    const createResponse = await this.createConfig(defaultData);
                    return createResponse;
                } catch (createError) {
                    // Se falhar ao criar, retorna dados padrão
                    return {
                        data: {
                            id: null,
                            ...defaultData
                        }
                    };
                }
            }
            throw error;
        }
    }

    async createConfig(data) {
        try {
            const response = await axios.post(this.url, {
                kanban_config: data,
            });
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateConfig(data) {
        try {
            const response = await axios.put(this.url, {
                kanban_config: data,
            });
            return response;
        } catch (error) {
            throw error;
        }
    }

    async deleteConfig() {
        try {
            const response = await axios.delete(this.url);
            return response;
        } catch (error) {
            throw error;
        }
    }

    async testWebhook() {
        try {
            const response = await axios.post(`${this.url}/test_webhook`);
            return response;
        } catch (error) {
            throw error;
        }
    }

    // Método para salvar ou atualizar configuração
    async saveConfig(data) {
        try {
            const currentConfig = await this.getConfig();

            if (currentConfig.data.id) {
                // Atualizar configuração existente
                return await this.updateConfig(data);
            } else {
                // Criar nova configuração
                return await this.createConfig(data);
            }
        } catch (error) {
            throw error;
        }
    }

    // Método para obter configurações específicas
    async getWebhookConfig() {
        try {
            const config = await this.getConfig();
            return {
                enabled: config.data.enabled || false,
                webhook_url: config.data.webhook_url || '',
                webhook_secret: config.data.webhook_secret || '',
                webhook_events: config.data.webhook_events || []
            };
        } catch (error) {
            throw error;
        }
    }

    // Método para obter configurações gerais
    async getGeneralConfig() {
        try {
            const config = await this.getConfig();
            return config.data.config || {
                title: 'Kanban',
                default_view: 'kanban',
                auto_assignment: false,
                notifications_enabled: false,
                support_email: '',
                support_phone: '',
                support_chat_hours: '',
                support_chat_enabled: false,
                dragbar_enabled: true
            };
        } catch (error) {
            throw error;
        }
    }

    // Método para atualizar apenas configurações de webhook
    async updateWebhookConfig(webhookData) {
        try {
            const currentConfig = await this.getConfig();
            const updatedData = {
                ...currentConfig.data,
                ...webhookData
            };

            return await this.saveConfig(updatedData);
        } catch (error) {
            throw error;
        }
    }

    // Método para atualizar apenas configurações gerais
    async updateGeneralConfig(generalData) {
        try {
            const currentConfig = await this.getConfig();
            const updatedData = {
                ...currentConfig.data,
                config: {
                    ...currentConfig.data.config,
                    ...generalData
                }
            };

            return await this.saveConfig(updatedData);
        } catch (error) {
            throw error;
        }
    }
}

export default new KanbanConfigAPI();
